import React from "react";
import { AlertCircle, Lock, ShieldCheck, Sparkles, UserCheck, Users } from "lucide-react";

const Icons = { AlertCircle, Lock, ShieldCheck, Sparkles, UserCheck, Users };

const LABELS = [
  { icon: Icons.Lock, text: "Privacy-by-design" },
  { icon: Icons.Users, text: "Human-in-the-loop" },
  { icon: Icons.Sparkles, text: "AI-assisted insights" },
  { icon: Icons.ShieldCheck, text: "GDPR principles" },
  { icon: Icons.AlertCircle, text: "No diagnosis" },
  { icon: Icons.UserCheck, text: "Professional review encouraged" },
];

export default function TrustStripSection() {
  return (
    <section data-testid="trust-strip" className="py-10 md:py-12 bg-slate-50 border-y border-slate-200">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-3">
          {LABELS.map((l) => (
            <div
              key={l.text}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white border border-slate-200 text-xs sm:text-sm text-slate-700"
            >
              <l.icon className="w-3.5 h-3.5 text-cyan-700" />
              <span className="font-medium">{l.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
